import { Link } from "react-router-dom";

const quickLinks = [
  {
    href: "/about",
    title: "학원소개",
    desc: "교육 철학과 강사진을 소개합니다",
    gradient: "from-blue-500 to-blue-600",
    icon: "ri-school-line",
  },
  {
    href: "/notice",
    title: "공지사항 및 시간표",
    desc: "최신 공지와 수업 시간표를 확인하세요",
    gradient: "from-emerald-500 to-emerald-600",
    icon: "ri-file-list-3-line",
  },
  {
    href: "/materials",
    title: "학습자료실",
    desc: "학년별·과목별 학습자료를 제공합니다",
    gradient: "from-violet-500 to-violet-600",
    icon: "ri-book-open-line",
  },
  {
    href: "/videos",
    title: "동영상 자료실",
    desc: "강의 동영상을 온라인으로 시청하세요",
    gradient: "from-orange-500 to-orange-600",
    icon: "ri-play-circle-line",
  },
  {
    href: "/location",
    title: "오시는 길",
    desc: "학원 위치와 교통편을 안내합니다",
    gradient: "from-rose-500 to-rose-600",
    icon: "ri-map-pin-2-line",
  },
];

export default function QuickLinksSection() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#1E3A5F] mb-3">바로가기</h2>
          <p className="text-slate-500">원하시는 정보를 빠르게 찾아보세요</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {quickLinks.map((link) => (
            <Link key={link.href} to={link.href} className="group">
              <div className="bg-white rounded-xl border border-slate-100 h-full hover:-translate-y-1 transition-all duration-300 hover:border-slate-200">
                <div className="p-6 flex items-start gap-4">
                  <div
                    className={`w-12 h-12 bg-gradient-to-br ${link.gradient} rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform`}
                  >
                    <i className={`${link.icon} text-white text-xl`} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <h3 className="font-bold text-[#1E3A5F] mb-1 group-hover:text-[#2563EB] transition-colors">
                        {link.title}
                      </h3>
                      <i className="ri-arrow-right-s-line text-slate-300 group-hover:text-[#2563EB] transition-colors" />
                    </div>
                    <p className="text-sm text-slate-500">{link.desc}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
